import { Epic } from 'modules/store'
import { combineEpics } from 'redux-observable'
import { concatAll, switchMap } from 'rxjs/operators'

import { AppProviders } from '../../app.module'

import { createErrorToast, PersonApiGetDto } from '../../shared'
import { sharedActions } from '../../shared/store'

import * as userActions from './person.actions'

const NAMESPACE = 'team'
const PERSONS_NAMESPACE = 'persons'
const api = {
  hierarchyToCurrent: (personId: number) => `${NAMESPACE}/${personId}/hierarchy`,
  hierarchyToRoot: (personId: number) => `${PERSONS_NAMESPACE}/${personId}/supervisors`,
}

export const userHierarchyToCurrentEpic: Epic<any, any, AppProviders> = (actions$, _, { httpClient }) => {
  return actions$
    .ofType<userActions.GetPersonHierarchyFromIdToCurrentAction>(sharedActions.GET_HIERARCHY_ID_TO_CURRENT)
    .pipe(
      switchMap((action) => {
        return httpClient
          .get<PersonApiGetDto[]>(api.hierarchyToCurrent(action.payload))
          .then(({ data }) => [new sharedActions.GetPersonHierarchyFromIdToCurrentSuccessAction(data)])
          .catch((reason) => {
            const toastr = createErrorToast(reason)

            return [
              new sharedActions.AddToastAction(toastr),
              new sharedActions.GetPersonHierarchyFromIdToCurrentFailureAction(reason),
            ]
          })
      }),
      concatAll()
    )
}

export const userHierarchyToRootEpic: Epic<any, any, AppProviders> = (actions$, _, { httpClient }) => {
  return actions$.ofType<userActions.GetPersonHierarchyFromIdToRootAction>(sharedActions.GET_HIERARCHY_ID_TO_ROOT).pipe(
    switchMap((action) => {
      return httpClient
        .get<PersonApiGetDto[]>(api.hierarchyToRoot(action.payload))
        .then(({ data }) => [new sharedActions.GetPersonHierarchyFromIdToRootSuccessAction(data)])
        .catch((reason) => {
          const toastr = createErrorToast(reason)

          return [
            new sharedActions.AddToastAction(toastr),
            new sharedActions.GetPersonHierarchyFromIdToRootFailureAction(reason),
          ]
        })
    }),
    concatAll()
  )
}

export default combineEpics(userHierarchyToCurrentEpic, userHierarchyToRootEpic)



// WEBPACK FOOTER //
// ./src/app/shared/store/person.epic.ts